import React, { useEffect, useState } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import { OPCIONES } from './Styles/StylesAsistencia';

import cintillo from "../../assets/img/cintillo_membrete.jpg";

const RendimientoPorCarrera = (props) => {
    const [boton1, setBoton1] = useState({ icon: "fa fa-ellipsis-v text-muted", disabled: false });

    const styles2 = StyleSheet.create(CONSTANCIA[0]);
    const styles = StyleSheet.create(OPCIONES[0]);

    return(
        <PDFViewer style = {styles2.section}>
            <Document title = "Rendimiento Académico">
                <Page size = "letter" orientation = 'landscape' style={styles2.body}>
                    <View style = {styles2.row}>
                        <Image
                            style = {[styles.colContent40, styles.logo]}
                            src = {cintillo}
                        />
                        <View style={[styles.row, {height: 20, marginTop: 3, /* backgr */}]}>
                            <Text style={[styles.col7, {marginTop: 20, fontFamily: 'Helvetica-Bold' /* fontSize: 18, textDecoration: "underline" */}]}>REGISTRO DE CALIFICACIONES</Text>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    )
}

export default RendimientoPorCarrera;


// WEBPACK FOOTER //
// ./src/components/Reportes/RendimientoPorCarrera.jsx